import Vue from 'vue';
import Router from 'vue-router';
import Digital from './Views/Digital.vue';
import Unsubscribe from './Views/Unsubscribe.vue';
import Widget from './Views/Widget.vue';

Vue.use(Router);

const router: Router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'tablet',
      path: '/tablet/:apitoken/:storeId/:employeeId',
      component: Digital,
    },
    {
      name: 'totem',
      path: '/totem/:apitoken/:storeId/:employeeId',
      component: Digital,
    },
    {
      name: 'unsubscribe',
      path: '/:apitoken/unsubscribe/:email?',
      component: Unsubscribe,
    },
    {
      name: 'widget',
      path: '/widget/:apitoken/:template?/',
      component: Widget,
    },
    {
      name: 'digital',
      path: '/:apitoken/:transactionId/:attemptId/:template?',
      component: Digital,
    },
    {
      name: 'digital_url',
      path: '/:apitoken/:template?/',
      component: Digital,
    },
  ],
});

export default router;
